import {ThemeProvider} from "styled-components"
import {theme} from "antd"


const Styled = ({children}) => {

	const {token} = theme.useToken()

	return (
		<ThemeProvider theme={token}>
			{children}
		</ThemeProvider>
	)
}

export default Styled
